// ----------------------------------------------------------------------
function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '';
const ROOTS_DASHBOARD = '';
const ROOTS_PROJECTS = '/projects';
const ROOTS_JOBS = '/';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  resetConfirmPassword: path(ROOTS_AUTH, '/reset-confirm-password'),
  verify: path(ROOTS_AUTH, '/verify'),
  userDone: path(ROOTS_AUTH, '/user-done'),
};
export const PATH_PROFILE = {
  locationsDetails: ROOTS_DASHBOARD,
  prevProj: path(ROOTS_AUTH, '/project-preview'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    profile: path(ROOTS_DASHBOARD, '/profile'),
  },
  app: path(ROOTS_DASHBOARD, '/dashboard'),
  setting: path(ROOTS_DASHBOARD, '/setting'),
  myContact: path(ROOTS_DASHBOARD, '/contacts'),
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  // resumes: path(ROOTS_DASHBOARD, '/resumes'),
  // coverLetter: path(ROOTS_DASHBOARD, '/coverLetter'),
  inBox: {
    root: path(ROOTS_DASHBOARD, '/inbox'),
    inbox: path(ROOTS_DASHBOARD, '/inbox/inbox'),
    notification: path(ROOTS_DASHBOARD, '/inbox/notification'),
    enquiry: path(ROOTS_DASHBOARD, '/inbox/enquiry'),
  },
  subscription: path(ROOTS_DASHBOARD, '/subscription'),
  website: path(ROOTS_DASHBOARD, '/website'),
  networking: path(ROOTS_DASHBOARD, '/networking'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  jobs: {
    root: path(ROOTS_DASHBOARD, '/jobs'),
    postings: path(ROOTS_DASHBOARD, '/jobs/postings'),
    create: path(ROOTS_DASHBOARD, '/jobs/create'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/personal-info'),
  },
  search: {
    root: path(ROOTS_DASHBOARD, '/search'),
    talentSearch: path(ROOTS_DASHBOARD, '/search/talentSearch'),
    talentSearchResult: path(ROOTS_DASHBOARD, '/search/talentSearchResult'),
    talentSearchMain: path(ROOTS_DASHBOARD, '/search/talentSearchMain'),
  },
  connectnetwork: {
    root: path(ROOTS_DASHBOARD, '/network'),
    followers: path(ROOTS_DASHBOARD, '/network/followers'),
    following: path(ROOTS_DASHBOARD, '/network/following'),
    mynetwork: path(ROOTS_DASHBOARD, '/network/mynetwork'),
    myinvitation: path(ROOTS_DASHBOARD, '/network/myinvitation'),
    network: path(ROOTS_DASHBOARD, '/network/network'),

  },
  project: {
    root: path(ROOTS_DASHBOARD, '/project'),
    projectDetails: path(ROOTS_DASHBOARD, '/project/project-details'),
    photos: path(ROOTS_DASHBOARD, '/project/photos'),
    videos: path(ROOTS_DASHBOARD, '/project/videos'),
    projectCreate: path(ROOTS_DASHBOARD, '/project/project-create'),
    projectView: path(ROOTS_DASHBOARD, '/project/project'),
    projectPreview: path(ROOTS_DASHBOARD, '/project/project-preview'),
    projects: path(ROOTS_DASHBOARD, '/project/list'),
    teams: path(ROOTS_DASHBOARD, '/project/teams'),
    createmember: path(ROOTS_DASHBOARD, '/project/createmember'),
    Viewproject: path(ROOTS_DASHBOARD, '/project/project-view'),
  },
  reports: {
    root: path(ROOTS_DASHBOARD, '/report'),
    activity: path(ROOTS_DASHBOARD, '/report/activity'),
  },
};
export const PATH_PROJECTS = {
  root: path(ROOTS_PROJECTS, '/projects'),
  projects: {
    mainDashboard: path(ROOTS_PROJECTS, '/dashboard'),
    projectDashboard: path(ROOTS_PROJECTS, '/projectDashboard'),
    QuickTemplate: path(ROOTS_PROJECTS, '/team_quick'),
    DetailedTemplate: path(ROOTS_PROJECTS, '/team_details'),
    projectDepartments: path(ROOTS_PROJECTS, '/projectDepartments'),
    newsUpdate: path(ROOTS_PROJECTS, '/newsUpdate'),
    remuneration: path(ROOTS_PROJECTS, '/remuneration'),
    remunerationDetailed: path(ROOTS_PROJECTS, '/remuneration-detailed'),
    remunerationInvoice: path(ROOTS_PROJECTS, '/remuneration-invoice'),
    projectSettings: path(ROOTS_PROJECTS, '/projectSettings'),
    budget: path(ROOTS_PROJECTS, '/budget'),
    wages: path(ROOTS_PROJECTS, '/wages'),
    timeLine: path(ROOTS_PROJECTS, '/timeLine'),
    reports: path(ROOTS_PROJECTS, '/reports'),
    jobs: path(ROOTS_PROJECTS, '/jobs'),
    teamDashboard: path(ROOTS_PROJECTS, '/teamDashboard'),
    Payments: path(ROOTS_PROJECTS, '/Payments'),
    Connect: path(ROOTS_PROJECTS, '/Connect'),
    teamReports: path(ROOTS_PROJECTS, '/teamReports'),
    TeamSettings: path(ROOTS_PROJECTS, '/TeamSettings'),
  },
};
export const PATH_JOBS = {
  root: path(ROOTS_DASHBOARD, '/jobs'),
  jobs: {
    Dashboard: path(ROOTS_DASHBOARD, '/jobs/Dashboard'),
    Candidates: path(ROOTS_DASHBOARD, '/jobs/Candidates'),
    Messages: path(ROOTS_DASHBOARD, '/jobs/Messages'),
    Interviews: path(ROOTS_DASHBOARD, '/jobs/Interviews'),
    Jobseek: path(ROOTS_DASHBOARD, '/jobs/Jobseek'),
    reports: path(ROOTS_DASHBOARD, '/jobs/reports'),
    timeline: path(ROOTS_DASHBOARD, '/jobs/timeline'),
    settings: path(ROOTS_DASHBOARD, '/jobs/settings'),
    ViewCandidate: path(ROOTS_DASHBOARD, '/jobs/ViewCandidate'),
    jobCreate: path(ROOTS_DASHBOARD, '/jobs/jobCreate'),
    JobOfficePreview: path(ROOTS_DASHBOARD, '/jobs/JobOfficePreview'),
    jobProjectCreate: path(ROOTS_DASHBOARD, '/jobs/jobProjectCreate'),
    jobProjectEdit: path(ROOTS_DASHBOARD, '/jobs/jobProjectEdit'),
    jobCompanyEdit: path(ROOTS_DASHBOARD, '/jobs/jobCompanyEdit'),
    jobProjectList: path(ROOTS_DASHBOARD, '/jobs/jobProjectList'),
    CastJobPosting: path(ROOTS_DASHBOARD, '/jobs/castJobPosting'),
    CrewJobPosting: path(ROOTS_DASHBOARD, '/jobs/crewJobPosting'),
  }
};
export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
